var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"demo-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v("EditorSender - 编辑器发送框")])]),_c('div',{staticClass:"demo-block"},[_c('h3',[_vm._v("基础用法")]),_c('BasicDemo')],1),_c('div',{staticClass:"demo-block"},[_c('h3',[_vm._v("自定义用法")]),_c('CustomDemo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }